import { RulesetCard } from "./RulesetCard";

export default RulesetCard;
